<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    市民中心站<br>
站点介绍<br>
市民中心站是2号线与4号线换乘站，站位于深南大道与金田路的交汇处，呈东西走向，东侧有金田路、金田立交桥，北侧为福中三路路，南侧是深南大道，西侧为市民中心广场，该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:13	23:53	2号线	2分35秒	5分45秒<br>
莲塘	06:08	23:47	2号线	2分35秒	5分45秒<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:17	23:52	2号线	4分钟	5分钟<br>
莲塘	06:08	23:47	2号线	4分钟	5分钟<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:17	00:42	2号线	4分钟	5分钟<br>
莲塘	06:08	00:47	2号线	4分钟	5分钟<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
金田路、海关大厦、地铁商业街、三寸时光地铁美食驿站<br><br>
B出入口:<br>
福中三路（东）、深圳博物馆、市大办公区、市民中心（东）、市行政服务大厅、安联大厦、中国凤凰大厦、诺德中心、荣超经贸大厦、雅颂居、第一健康体检中心<br><br>
C出入口:<br>
福中三路（西）、市民中心（南）、地铁商业街<br><br>
D出入口:<br>
深南大道、市民广场（南）、市民中心停车场<br><br>
E出入口:<br>
深南大道、市民广场东公交站<br><br>
F出入口:<br>
深南大道、金田路、市民广场东公交站 、卓悦中心<br><br>
公交换乘信息<br><br>
E出入口:<br>
公交站名： 市民广场东<br>
高快巴士18、高快巴士25、N3、M435、326<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "sihaoxian",
          title: "4号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>